export default "__VITE_ASSET__7IB8Bd2s__"